import React from 'react';
import {
	EmbeddedFeatureApp,
	TriggerProps,
	useFaContent,
} from 'src/feature-app';
import { CallMeForm } from 'src/forms/CallMe';
import { CallMeOfertasTrigger } from './CallMeOfertasTrigger';

const renderTrigger = (featureApp: EmbeddedFeatureApp, props: TriggerProps) => {
	const { setSelectedJourney } = props;
	if (featureApp === 'es-ofertas') {
		return <CallMeOfertasTrigger {...props} />;
	}
	if (featureApp === 'action') {
		setSelectedJourney(<CallMeForm />);
	}

	return null;
};

export function CallMeEmbeddedTrigger(props: TriggerProps) {
	const faContent = useFaContent();

	return renderTrigger(faContent.featureApp, props);
}
